import React from 'react';
import { AgxBodyText, AgxButton, AgxRow, AgxColumn, AgxHeader } from '@urbanx/agx-ui-components';
import { Breakpoints, ScreenSize } from 'utils/screen';
import QuestionMark from '../../assets/icons/question-mark-circle-outline.svg?react';
import ExclamationMark from '../../assets/icons/alert-circle-outline.svg?react';
import './ExistingPropertyFound.scss';

interface ExistingPropertyFoundProps {
  goToSearch: () => void;
  goToDashboard: () => void;
}

const ExistingPropertyFound: React.FC<ExistingPropertyFoundProps> = ({
  goToSearch,
  goToDashboard,
}) => {
  const screenSize = ScreenSize();
  const isDesktop = screenSize === Breakpoints.Desktop;
  const isMobile = screenSize === Breakpoints.Mobile;

  const ButtonGroup = isDesktop ? AgxRow : AgxColumn;

  return (
    <AgxColumn fill centerJustified centered extraLargeGap extraClasses="existingPropertyFound">
      <ExclamationMark width={48} height={48} />
      <AgxHeader size={2} inverse centered>
        An active campaign already exists for this address.
      </AgxHeader>

      <ButtonGroup largeGap fill={!isDesktop} centered={isDesktop}>
        <AgxButton
          primary
          large
          dark
          text="Search again"
          wide={!isDesktop && isMobile}
          onClick={goToSearch}
        />
        <AgxButton
          hollow
          large
          dark
          text="Back to the dashboard"
          wide={!isDesktop && isMobile}
          onClick={goToDashboard}
        />
      </ButtonGroup>
    </AgxColumn>
  );
};

export default ExistingPropertyFound;
